import { H2 } from '@comeon/ui';

import { textKeysNewQDAmountScreenHeader } from '~/components/payment/quick-deposit-beta/components-v2/constants';
import useTranslations from '~/components/translation/use-translations';
import { useCloseCurrentContext } from '~/hooks/use-close-context';
import usePaymentTracking from '~/components/payment-beta/deposit/hooks/use-payment-tracking';

// Styled components
import { CloseButton, Header } from './styles';

type Props = {
	disabled?: boolean;
	textHeading?: string;
};

const NewQuickDepositAmountScreenHeader = ({ disabled, textHeading }: Props) => {
	const closeCurrentContext = useCloseCurrentContext();
	const { trackQDEvent } = usePaymentTracking();
	const { translations } = useTranslations(textKeysNewQDAmountScreenHeader);
	const { NEW_QUICK_DEPOSIT_AMOUNT_SCREEN_HEADING } = translations;

	const handleCloseClick = () => {
		// Track close button click
		trackQDEvent({
			pixel_deposit_action: 'click-close-quick-deposit-modal'
		});
		closeCurrentContext();
	};

	return (
		<Header className="page-head__left-side" disabled={disabled}>
			<H2>{textHeading || NEW_QUICK_DEPOSIT_AMOUNT_SCREEN_HEADING}</H2>
			<CloseButton className="at-icon-close page-head__close" onClick={handleCloseClick} type="button" />
		</Header>
	);
};

export default NewQuickDepositAmountScreenHeader;
